import type { User } from 'lib/store'

import { getUserAuth } from './userAuth'

const billingAuthStorageKey = 'financedata-billing-auth'
const billingDesignStorageKey = 'financedata-billing-design'

export const billingAuth = {
	clear: () => {
		sessionStorage.removeItem(billingAuthStorageKey)
		sessionStorage.removeItem(billingDesignStorageKey)
	},
	saveDesign: () => {
		if (window.location.pathname.startsWith('/personal/')) sessionStorage.setItem(billingDesignStorageKey, 'personal')
		else sessionStorage.removeItem(billingDesignStorageKey)
	},
	restoreDesign: () => {
		if (!/^\/(?:billing\/?)?$/u.test(window.location.pathname)) return false
		if (sessionStorage.getItem(billingDesignStorageKey) !== 'personal') return false
		sessionStorage.removeItem(billingDesignStorageKey)
		if (getUserAuth(billingAuth.restore()).status !== 'authenticated') {
			billingAuth.clear()
			return false
		}
		window.history.replaceState(
			null,
			'',
			`/personal${window.location.pathname}${window.location.search}${window.location.hash}`,
		)
		return true
	},
	restore: () => {
		const value = sessionStorage.getItem(billingAuthStorageKey)
		if (!value) return

		try {
			return JSON.parse(value) as User
		} catch {
			billingAuth.clear()
		}
	},
	save: (user: User) => sessionStorage.setItem(billingAuthStorageKey, JSON.stringify(user)),
}
